module.exports = __webpack_public_path__ + "img/home-collect-free-masks.9d3ac4ef.png";